import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium, { StyleRoot } from 'radium';
import bgImage from '../static/images/index_bg.jpg';
import logoImage from '../static/images/logo_lg.png';
import IndexView from '../containers/Indexes'
import Helpers from '../helpers';
import Footer from './Footer.js';

const styles = {
  wrapper: {
    backgroundImage: `url(${logoImage}), url(${bgImage})`,
    width: '100%',
    height: '100%',
    display: 'block',
    backgroundSize: '215px 100px, cover',
    backgroundPosition: 'center 4%, center',
    backgroundRepeat: 'no-repeat',
    padding: '10% 0 0 0',
    position: 'relative',
    '@media (max-width: 767px)': {
      backgroundSize: 'calc(100% - 20px) auto, cover',
      height: 'initial',
      minHeight: '100%',
    },
  },
};

class IndexPage extends Component {

  render() {
    var query = this.props.location.query;
    if (Helpers.Session.isViaEmpty()) {
      Helpers.Session.saveVia(query);
    }

    return (
      <StyleRoot style={styles.wrapper}>
        <IndexView.Nav />
        <Footer />
      </StyleRoot>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./components/IndexPage.js